// ** Redux Imports
import { combineReducers } from "redux"

// ** Reducers Imports
import auth from "./auth"
import navbar from "./navbar"
import layout from "./layout"
import customer from "./customer"
import upload from "./upload"
import form from "./form"
import sms from "./sms"
import jobSite from "./job-site"
import google from "./google"
import employee from "./employee"
import subscription from "./subscription"
import company from "./company"
import schedule from "./schedule"
import payment from "./payment"
import shift from "./shift"
import rating from "./employee/rating"
import daysoff from "./daysoff"
import availability from "./availability"
import ticket from "./ticket"
import contactRequest from "./contact"
import shiftTemplate from "./shiftTemplates"
import scheduler from "./scheduler"
import chat from "./chat"
import dropShift from "./dropShiftRequest"
import statistics from "./statistics"
import adminStatistics from "./admin-statistics"
import insurance from "./insurance"
import dashboard from "./dashboard"
import activity from "./employee-activity"
import adminBalance from "./admin-balance"
import siteReducer from "./master-qr"
import validationLocation from "./validation-location"
import record from "./record"
// Import reminder reducer lazily to avoid circular dependencies
const reminder = (
  state = {
    list: {
      data: [],
      loading: false,
      error: null,
    },
    current: {
      data: null,
      loading: false,
      error: null,
    },
    saving: false,
    saveError: null,
    deleting: false,
    deleteError: null,
    reload: false,
  },
  action
) => {
  // This is a placeholder that will be replaced by the real reducer on first action
  if (!window.reminderReducerLoaded && action.type !== "@@INIT") {
    // Dynamically import the real reducer only when needed
    import("./reminder").then((module) => {
      window.reminderReducer = module.default
      window.reminderReducerLoaded = true
    })
    return state
  }

  // Once loaded, use the real reducer
  if (window.reminderReducerLoaded && window.reminderReducer) {
    return window.reminderReducer(state, action)
  }

  return state
}

const rootReducer = combineReducers({
  auth,
  navbar,
  layout,
  customer,
  upload,
  form,
  sms,
  jobSite,
  google,
  employee,
  subscription,
  company,
  payment,
  shift,
  rating,
  schedule,
  daysoff,
  availability,
  ticket,
  contactRequest,
  shiftTemplate,
  scheduler,
  chat,
  dropShift,
  statistics,
  adminStatistics,
  insurance,
  validationLocation,
  dashboard,
  activity,
  adminBalance,
  site: siteReducer,
  record,
  reminder,
})

export default rootReducer
